import { action, makeObservable, observable } from "mobx";

export type DisclosureStateArgs<AdditionalDataType extends object> = {
  onOpen?: (additionalData?: AdditionalDataType) => void;
  onClose?: () => void;
  isOpen?: boolean;
  onMinimize?: () => void;
};

export class DisclosureState<AdditionalDataType extends object> {
  @observable.ref
  isOpen: boolean;

  @observable
  additionalData?: AdditionalDataType;

  onOpenCallback?: (additionalData?: AdditionalDataType) => void;
  onCloseCallback?: () => void;

  constructor(args: DisclosureStateArgs<AdditionalDataType> = {}) {
    makeObservable(this);
    this.onOpenCallback = args.onOpen;
    this.onCloseCallback = args.onClose;
    this.isOpen = args.isOpen || false;
  }

  @action.bound
  onOpen(additionalData?: AdditionalDataType): void {
    this.additionalData = additionalData;
    this.onOpenCallback?.(additionalData);
    this.isOpen = true;
  }

  @action.bound
  onClose(): void {
    this.onCloseCallback?.();
    this.isOpen = false;
    this.additionalData = undefined;
  }

  @action.bound
  open(): void {
    this.isOpen = true;
  }

  @action.bound
  close(): void {
    this.isOpen = false;
  }

  @action.bound
  onToggle(additionalData?: AdditionalDataType): void {
    this.additionalData = additionalData;
    this.isOpen = !this.isOpen;
    if (this.isOpen) return;
    this.additionalData = undefined;
  }
}
